var map = {
	"./queries/products/Product": 445,
	"./queries/products/Product.gql": 445,
	"./queries/products/ProductsSearch": 420,
	"./queries/products/ProductsSearch.gql": 420,
	"./queries/products/SimilarProducts": 446,
	"./queries/products/SimilarProducts.gql": 446,
	"./queries/products/SuggestedProducts": 422,
	"./queries/products/SuggestedProducts.gql": 422,
	"./queries/promotions/Promotion": 447,
	"./queries/promotions/Promotion.gql": 447,
	"./queries/promotions/Promotions": 448,
	"./queries/promotions/Promotions.gql": 448,
	"./queries/promotions/PromotionsCarousel": 414,
	"./queries/promotions/PromotionsCarousel.gql": 414,
	"./queries/taxonomies/Brands": 416,
	"./queries/taxonomies/Brands.gql": 416,
	"./queries/taxonomies/Categories": 419,
	"./queries/taxonomies/Categories.gql": 419,
	"./queries/taxonomies/FooterTaxons": 305,
	"./queries/taxonomies/FooterTaxons.gql": 305,
	"./queries/taxonomies/MenuCategories": 199,
	"./queries/taxonomies/MenuCategories.gql": 199
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 875;